import React, { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import DropdownVoucherDynamicInput from '../../../../components/Dropdown/DropdownVoucherDynamicInput';
import { currencyFormate } from '../../../../components/Date_Formate_Utilitiy/Index';

export const VoucherContraInputRow = ({
  valueLoop,
  setValueLoop,
  showBorder,
  handleChange,
  handleFocus,
  handleBlur,
  inputRefs,
  dropList,
  narr_ref,
  handleDropdownDynamicClick,
  handleKeyDown,
  isView
}) => {
  const modal_state = useSelector(state => state.common.modal_state);

  // Memoize the input handlers
  const getInputHandlers = useCallback((id, field) => ({
    onChange: (e) => handleChange(e, id, field, e.target.value),
    onKeyUp: (e) => handleChange(e, id, field, e.target.value),
    onFocus: (e) => handleFocus(e, id, field, e.target.value),
    onBlur: (e) => handleBlur(e, id, field, e.target.value),
    onKeyDown: (e) => handleKeyDown(e, id, field)
  }), [handleChange, handleFocus, handleBlur, handleKeyDown]);

  // Memoize balance display calculation
  const shouldShowBalance = useCallback((item) => {
    return item?.first !== '' &&
      item?.first !== 'End of List' &&
      item?.particular_ledger_balance !== null &&
      item?.particular_ledger_balance !== undefined &&
      item?.particular_ledger_balance !== '';
  }, []);

  // Memoize balance class and text
  const getBalanceDisplay = useCallback((balance) => {
    const balanceNum = parseFloat(balance);
    return {
      className: balanceNum < 0 ? 'color_red' : 'text-muted',
      suffix: balance === 0 ? '' : balanceNum < 0 ? ' Cr' : ' Dr'
    };
  }, []);

  return (
    <div className='row p-0 m-0 mb-1'>
      {valueLoop?.data?.map((item, index) => {
        const firstInputHandlers = getInputHandlers(item?.id, 'first');
        const amountInputHandlers = getInputHandlers(item?.id, 'particular_ledger_pay_amount');
        const balanceDisplay = getBalanceDisplay(item?.particular_ledger_balance);

        return (
          <div
            key={item?.id || `contra-row-${index}`}
            className={`col-12 ${showBorder ? 'border-bottom border-dark' : ''}`}
            style={{ height: 40, backgroundColor: 'transparent' }}
          >
            <div className='row' style={{ height: 40 }}>
              <div className='col-4 m-0 p-0 container_of_voucher_input'>
                <span className='ps-2'>{item?.first === 'End of List' ? '' : `${valueLoop?.voucher_type_name?.toLowerCase() === "payment" ||
                  valueLoop?.select_type_of_voucher?.toLowerCase() === "payment" ? "Dr" : "Cr"}`}</span> <input
                  type='text'
                  name={`first_${index}`}
                  ref={(el) => {
                    if (!inputRefs.current[item?.id]) {
                      inputRefs.current[item?.id] = {};
                    }
                    inputRefs.current[item?.id].first = el;
                  }}
                  className='voucher_entry_account_input'
                  value={item?.first === 'End of List' ? '' : (item?.first || '')}
                  disabled={isView}
                  {...firstInputHandlers}
                />
              </div>

              {modal_state[`first${item?.id}`] && (
                <DropdownVoucherDynamicInput
                  title={'List of Ledger Account'}
                  state={modal_state[`first${item?.id}`]}
                  data={valueLoop}
                  setData={setValueLoop}
                  input_value={item?.first}
                  input_key={'first'}
                  input_id={'particular_ledger_id'}
                  input_blc={'particular_ledger_balance'}
                  rawData={dropList}
                  index={index}
                  rowId={item?.id}
                  modal_id={item?.id}
                  ref={inputRefs.current[item?.id]?.first}
                  refs={inputRefs}
                  narr_ref={narr_ref}
                  isDynamic={true}
                  handleDropdownClick={handleDropdownDynamicClick}
                />
              )}

              <div className='col-6' />

              <div className='col-2 m-0 p-0 container_of_voucher_input'>
                {item?.first !== 'End of List' && (
                  <input
                    type='text'
                    style={{ textAlign: 'right', paddingRight: 5 }}
                    name={`particular_ledger_pay_amount_${index}`}
                    ref={(el) => {
                      if (!inputRefs.current[item?.id]) {
                        inputRefs.current[item?.id] = {};
                      }
                      inputRefs.current[item?.id].particular_ledger_pay_amount = el;
                    }}
                    className='voucher_entry_account_input'
                    value={item?.particular_ledger_pay_amount || ''}
                    disabled={isView}
                    {...amountInputHandlers}
                  />
                )}
              </div>

              <div className='col-6 m-0 ms-5'>
                {shouldShowBalance(item) && (
                  <div className='row' style={{ height: 19.5 }}>
                    <div className='col-1 p-0 m-0 font_size' style={{ textAlign: 'left', width: '8.5%' }}>
                      Cur Bal:
                    </div>
                    <div className='col-2 m-0 p-0 font_size' style={{ textAlign: 'right', height: 19.5 }}>
                      <span className={balanceDisplay.className}>
                        {currencyFormate(item?.particular_ledger_balance)}
                      </span>
                    </div>
                    <div className='col-2 m-0 p-0 ps-1 font_size' style={{ textAlign: 'left', height: 19.5 }}>
                      <span className={balanceDisplay.className}>
                        {balanceDisplay.suffix}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};